import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { isFeatureFlagEnabled, POSTHOG_ENABLED } from '../lib/posthog'

export default function useFeatureFlag (opts = {}) {
  const { featureFlag, user, redirectTo } = opts || {}
  const history = useHistory()
  const [enabled, setEnabled] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!POSTHOG_ENABLED) {
      // fail open on dev, fail shut elsewhere
      setEnabled(process.env.NODE_ENV === 'development')
      setLoading(false)
      return
    }

    let mounted = true
    setLoading(true)
    setError(null)

    async function check () {
      try {
        const result = await isFeatureFlagEnabled({ featureFlag, user, enableForAdmin: false, enableIfOptedOut: false })
        if (!mounted) return
        setEnabled(Boolean(result))
        setLoading(false)
        if (!result && redirectTo) {
          // perform client-side redirect
          history.replace(redirectTo)
        }
      } catch (err) {
        if (!mounted) return
        setError(err)
        setEnabled(false)
        setLoading(false)
        if (redirectTo) history.replace(redirectTo)
      }
    }

    if (featureFlag) check()
    else {
      setEnabled(false)
      setLoading(false)
    }

    return () => {
      mounted = false
    }
  }, [featureFlag, user, redirectTo])

  return { enabled, loading, error }
}
